<angie-primary-spinner></angie-primary-spinner>
<section id="main-content" angieAppLayoutType>
	<div class="wrap">
		<router-outlet></router-outlet>
	</div>
</section>
<angie-default-footer></angie-default-footer>
